import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=34fb273b&scoped=true"
import script from "./Agregar.vue?vue&type=script&lang=js"
export * from "./Agregar.vue?vue&type=script&lang=js"
import style0 from "./Agregar.vue?vue&type=style&index=0&id=34fb273b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb273b",
  null
  
)

export default component.exports